define('views/modules/calendar/nutrition/nutrient/nutrient-component',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/nutrition/nutrients',
    // collections
    'collections/calendar/nutrition/nutrients',
    // views
    'src/views/click-outside-view',
    'views/modules/calendar/nutrition/nutrient/list/nutrient-list',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    NutrientService,
    // collections
    CNutrients,
    // views
    VClickOutside,
    VNutrientList
) {

    var VNutrientComponent = VClickOutside.extend({
        className: "macronutriments",
        initialize: function(opt) {
            var options = this.options = _.extend({
                inline: false,
                dark: true,
            }, opt);
            this.nutrients = new Backbone.Model();
            this.collection = new CNutrients();
            this.macro = new CNutrients(null, { macro: true });
            this.micro = new CNutrients();

            this.inline = options.inline;

            this.view = {
                macro: new VNutrientList({ title: "calendar:Macronutrients", collection: this.macro }),
                micro: new VNutrientList({ title: "calendar:Micronutrients", collection: this.micro }),
            };

            this.onNutrientSync();

            this.listenTo(this.nutrients, 'model:reset', this.onNutrientReset);
            this.listenToOnce(NutrientService, 'sync', this.onNutrientSync);
        },

        render: function() {
            var view = this.view,
                $el = this.$el;
            $el.empty();
            this.toggle(this.inline);
            $el.append(view.macro.render().el)
                .append(view.micro.render().el);

            this.toggleInline(this.inline)
                .toggleDark(this.options.dark);

            return this;
        },

        renderList: function() {
            var view = this.view;
            view.macro.render();
            view.micro.render();
        },

        toggleInline: function(value) {
            if (_.isUndefined(value)) value = !this.inline;
            this.inline = value;
            this.$el.toggleClass('arrow-box top', !value)
                .toggleClass('inline', value);
            return this;
        },

        toggleDark: function(value) {
            this.$el.toggleClass('dark', value);
            return this;
        },

        toggle: function(value) {
            if (!_.isUndefined(value)) value = !value;
            this.$el.toggleClass('hidden', value);
            this.focus();
        },

        setNutrients: function(nutrients) {
            if (!nutrients) this.collection.setModelAttributes({ value: 0 });
            this.nutrients.reset(nutrients);
        },

        setServing: function(serving) {
            this.view.macro.setServing(serving);
        },

        applyNutrientsValues: function() {
            this.collection.setNutrients(this.nutrients.attributes);
            this.renderList();
        },

        ////////////
        // events //
        ////////////
        onNutrientSync: function() {
            var view = this.view,
                macro = this.macro,
                micro = this.micro,
                collection = this.collection;
            collection.reset();
            macro.reset(NutrientService.getMacronutrients());
            micro.reset(NutrientService.getMicronutrients());
            collection.add(macro.models);
            collection.add(micro.models);
            this.applyNutrientsValues();
        },

        onNutrientReset: function() {
            this.applyNutrientsValues();
        },

        onClickOutside: function(e) {
            if (!this.options.inline) {
                this.toggle(false);
            }
        },

    });

    return VNutrientComponent;
});

